/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponseData;

  constructor(
    err: PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse";
  }
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse(
        v,
      );
    });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse
  > = z.instanceof(PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$Outbound;
}
